import { Infer, array, is, object, optional, string } from 'superstruct';
import { useFeatureServices } from '../services/use-feature-services';

const Content = object({
  titleText: optional(string()),
  tweetsIds: optional(array(string())),
});

export type FeatureAppContent = Infer<typeof Content>;

export function useFeatureAppContent(): FeatureAppContent {
  const { 'fa-content-service': contentService } = useFeatureServices();
  const content = contentService?.content;
  return is(content, Content) ? content : { titleText: '', tweetsIds: [] };
}
